<!-- <a href="https://superiorsystems.in/apple" target="_blank" class="floating-coin">
    <div class="coin">
      <div class="front">
        <img src="assets/images/superior.png" alt="Logo">
      </div>
      <div class="back">
        <img src="assets/images/authorized.png" alt="Logo">
      </div>
    </div>
  </a> -->
  
  <div class="page-title-area">
      <img src="assets/images/networking_banner.jpeg" alt="Page Background" class="page-bg">
      <button class="back-arrow-btn" (click)="navigateToHome()">
          <i class="fas fa-chevron-left fa-2x"></i>
      </button>
      <div class="container">
          <div class="page-title-content">
              <h2>Networking</h2>
          </div>
      </div>
  
      <div class="page-shape">
          <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
          <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
          <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
          <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
          <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
      </div>
  </div>
  
  <section class="services-details-area ptb-100">
      <div class="container">
          <div class="scrives-item-2 mt-4 ">
              <div class="row align-items-center">
                  <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                      <div class="services-img mb-qc ios-content">
                          <div class="circular-layout">
                              <div class="image-container">
                                <img src="assets/images/networking1.jpeg" alt="image" class="image-container-img"/>
                              </div>
                            </div>
                         <!--  <div class="image-wrapper">
                              <div class="background-shape shape1"></div>
                              <div class="background-shape shape2"></div>
                              <img src="assets/images/net2.png" alt="Person">
                          </div> -->
                      </div>
                  </div>
  
                  <div class="col-lg-6">
                      <p>Networking is essential for modern business infrastructure, enabling seamless communication and data exchange. Our approach starts with designing network cabling for efficient data flow and minimal interference. </p>
                      <p> We choose superior switches and strategic access points to optimise connectivity and reduce latency. </p>
                  </div>
              </div>
          </div>
  
          <br>
          <br>
  
          <div class="scrives-item-2 mt-4 ">
              <div class="row align-items-center">
                  <div class="col-lg-6">
                      <p> With expert installation, we ensure a strong, scalable network infrastructure customised to your needs. Our rigorous testing and certification processes confirm peak performance and compliance with industry standards. </p>
                      <p>We use advanced tools to monitor network health and address potential issues proactively. Our team is ready to support and guide you, ensuring reliable networks that meet evolving technological demands. </p>
                  </div>
  
                  <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                      <div class="services-img mb-qc ios-content">
                          <div class="circular-layout">
                              <div class="image-container">
                                <img src="assets/images/networking2.jpg" alt="image" class="image-container-img"/>
                              </div>
                            </div>
                         <!--  <div class="image-wrapper">
                              <div class="background-shape shape1"></div>
                              <div class="background-shape shape2"></div>
                              <img src="assets/images/net3.png" alt="Person">
                          </div> -->
                      </div>
                  </div>
              </div>
          </div>
  
          <!-- <br>
          <br>
  
          <div class="scrives-item-2 mt-4 ">
              <div class="row align-items-center">
                  <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                      <div class="services-img mb-qc ios-content">
                          <div class="image-wrapper">
                              <div class="background-shape shape1"></div>
                              <div class="background-shape shape2"></div>
                              <img src="assets/images/solutions-details/55.png" alt="Person">
                          </div>
                      </div>
                  </div>
  
                  <div class="col-lg-6">
                      <p>Superior Digital hosted a team get-together with our Sales, Pre-Sales Team, and Business Head to foster collaboration and align on our shared vision. The session focused on understanding each team member's strengths and expertise, enabling us to work more effectively together. </p>
                  </div>
              </div>
          </div>
  
          <br>
          <br> -->
  
          <div class="scrives-item-2 mt-4 ">
              <div class="row align-items-center">
                  <div class="col-lg-12">
                      <p> Connect with us to enhance your connectivity experience today!</p>
                  </div>
  
                  <!-- <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                      <div class="services-img mb-qc ios-content">
                          <div class="image-wrapper">
                              <div class="background-shape shape1"></div>
                              <div class="background-shape shape2"></div>
                              <img src="assets/images/solutions-details/56.png" alt="Person">
                          </div>
                      </div>
                  </div> -->
              </div>
          </div>
      </div>
  </section>
  
  <div class="container mb-4">
      <div class="d-flex justify-content-end">
          <button class="btn back-btn" (click)="navigateToHome()">
              <i class="fas fa-arrow-left me-2"></i> Back to Home
          </button>
      </div>
  </div>
  